import { appAlert } from "./appDialogs";
import { API_ORIGIN, apiUrl } from "./apiOrigin";
// protectedExport.js  (2026-10)
// -----------------------------------------------------------------------------
// Download a staff / pay spreadsheet PIN-protected. The workbook is built in
// the browser as before, sent to the server (POST /api/headoffice/protect-export,
// headoffice.js v56), encrypted with the organisation's export PIN (Settings →
// Organisation) using standard Office encryption, and the protected file is
// downloaded — Excel asks for the PIN when it is opened.
//
// Fails CLOSED: if the file can't be protected (server error, encryption
// unavailable) nothing is downloaded. An organisation still on the default
// PIN (12345) is reminded once per session to change it.
//
// Used by: ClockInOut.js (day, month and tab exports), stafflogin.js (Raw
// data), staff_dev.js, PharmacistRota.js (payment schedules).
// -----------------------------------------------------------------------------
const API = apiUrl("");
const XLSX_MIME = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
const token = () => localStorage.getItem("token") || localStorage.getItem("authToken") || localStorage.getItem("jwt") || "";
function toBase64(bytes) {
  let s = "";
  const CH = 0x8000;
  for (let i = 0; i < bytes.length; i += CH) s += String.fromCharCode.apply(null, bytes.subarray(i, i + CH));
  return btoa(s);
}
function fromBase64(b64) {
  const s = atob(b64);
  const out = new Uint8Array(s.length);
  for (let i = 0; i < s.length; i++) out[i] = s.charCodeAt(i);
  return out;
}
function download(bytes, filename) {
  const url = URL.createObjectURL(new Blob([bytes], {
    type: XLSX_MIME
  }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
let warnedDefault = false;

// data: ArrayBuffer | Uint8Array | number[] of a complete .xlsx file.
export async function saveXlsxProtected(data, filename) {
  const bytes = data instanceof Uint8Array ? data : new Uint8Array(data);
  try {
    const r = await fetch(`${API}/api/headoffice/protect-export`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token()}`
      },
      body: JSON.stringify({
        filename,
        dataBase64: toBase64(bytes)
      })
    });
    const text = await r.text();
    let d = {};
    try {
      d = JSON.parse(text);
    } catch (_) {
      throw new Error(`the server could not protect it (HTTP ${r.status})`);
    }
    if (!r.ok || !d.dataBase64) throw new Error(d.error || `HTTP ${r.status}`);
    if (!d.protected) throw new Error("the server returned it unprotected");
    download(fromBase64(d.dataBase64), filename);
    if (d.isDefaultPin && !warnedDefault) {
      warnedDefault = true;
      (await appAlert("This spreadsheet is protected with the DEFAULT export PIN, 12345.\n\nPlease change it in Settings → Organisation Settings → Export PIN, so only your team can open staff and pay spreadsheets."));
    }
    return {
      protected: !!d.protected
    };
  } catch (e) {
    (await appAlert(`Not downloaded — the spreadsheet could not be PIN-protected: ${e.message || e}`));
    return {
      protected: false,
      error: e.message || String(e)
    };
  }
}

// Convenience for SheetJS / xlsx-js-style workbooks: replaces XLSX.writeFile(wb, name).
export function saveWorkbookProtected(XLSX, wb, filename) {
  const data = XLSX.write(wb, {
    type: "array",
    bookType: "xlsx"
  });
  return saveXlsxProtected(data, filename);
}
